<template>
	<div class="job--edit--languages-item">
		<div class="job--edit--languages-item-select-item">
			<div>
				<FormGroup :state="itemValid">
					<SingleSelect
						v-model="item"
						:characteristics="languageOptions"
						@change="emitChangeEvent"
					/>
				</FormGroup>
			</div>
			<div>
				<b-form-checkbox v-model="mother" @change="emitChangeEvent">Muttersprache</b-form-checkbox>
			</div>
			<div>
				<a href="#" @click.prevent="$emit('remove')">
					<Icon icon="bin"/>
				</a>
			</div>
		</div>
		<div v-if="specificitiesEligible" class="job--edit--languages-item-specificities">
			<b-row>
				<b-col
					v-for="specificityTypeAllocation in specificityTypes"
					:key="specificityTypeAllocation.id"
					md="6"
				>
					<div class="job--edit--languages-item-specificities-item">
						<div>{{ specificityTypeAllocation.specificityType.label }}</div>
						<div>
							<FormGroup>
								<Select
									:value="getSpecificityValue(specificityTypeAllocation.specificityType)"
									:options="getAllocationOptions(specificityTypeAllocation.specificityType)"
									@change="specificityChanged(specificityTypeAllocation.specificityType, $event)"
								/>
							</FormGroup>
						</div>
					</div>
				</b-col>
			</b-row>
		</div>
	</div>
</template>

<script>
import SingleSelect from "@/vue/characteristic/SingleSelect";
import {mapState} from "vuex";
import {isDefined} from "@/helper/Value";
import Icon from "@/vue/icon/Icon"
import FormGroup from "@/vue/common/form/Group";
import _ from "lodash";
import {LANGUAGE_MOTHER} from "@/helper/job-profile/SpecificityType";
import Select from "@/vue/common/form/Select";
import {LANGUAGE_MOTHER_NO, LANGUAGE_MOTHER_YES} from "@/helper/characteristic/NaturalId";

export default {

	components: {
		Select,
		FormGroup,
		SingleSelect,
		Icon,
	},

	props: {
		language: {
			type: Object,
			required: true,
		},
		usedLanguages: {
			type: Array,
			required: true,
		},
	},

	data ()
	{
		let specificities = this.language.specificities;

		let mother = isDefined(
			_.find(specificities, item => item.specificity.naturalId === LANGUAGE_MOTHER_YES)
		);

		// filter out mother specificity
		specificities = _.filter(specificities, item => item.specificityType.id !== LANGUAGE_MOTHER);

		return {
			item: this.language.item,
			mother,
			specificities,
		};
	},

	computed: {
		...mapState('meta', ['meta']),
		specificitiesEligible ()
		{
			return isDefined(this.item) && !this.mother;
		},
		motherSpecificityType ()
		{
			return _.find(
				this.meta.languageType.specificityTypes,
				specificityTypeAllocation => specificityTypeAllocation.specificityType.id === LANGUAGE_MOTHER
			).specificityType;
		},
		motherSpecificity ()
		{
			const naturalId = this.mother ? LANGUAGE_MOTHER_YES : LANGUAGE_MOTHER_NO;

			return _.find(
				this.motherSpecificityType.allocations,
				specificityAllocation => specificityAllocation.specificity.naturalId === naturalId
			).specificity;
		},
		specificityTypes ()
		{
			return _.filter(this.meta.languageType.specificityTypes, specificityTypeAllocation =>
			{
				return specificityTypeAllocation.specificityType.id !== this.motherSpecificityType.id;
			});
		},
		languageOptions ()
		{
			const usedLanguageIds = _.map(this.usedLanguages, 'id');

			return _.filter(this.meta.language, characteristicItem =>
			{
				// do not exclude our own language
				if (this.item && this.item.id === characteristicItem.id)
				{
					return true;
				}

				return !_.includes(usedLanguageIds, characteristicItem.id);
			});
		},
		itemValid ()
		{
			return isDefined(this.item);
		},
		specificitiesValid ()
		{
			return !this.specificitiesEligible || this.specificities.length === this.specificityTypes.length;
		},
		valid ()
		{
			return this.itemValid
				&& this.specificitiesValid;
		},
	},

	methods: {
		getAllocationOptions (specificityType)
		{
			return _.map(
				specificityType.allocations,
				allocation =>
				{
					return {
						value: allocation.specificity,
						text: allocation.specificity.label,
					};
				}
			);
		},
		getSpecificityValue (specificityType)
		{
			const valueItem = _.find(
				this.specificities,
				specificityItem => specificityItem.specificityType.id === specificityType.id
			);

			return valueItem ? valueItem.specificity : undefined;
		},
		specificityChanged (specificityType, value)
		{
			this.specificities = _.filter(
				this.specificities,
				specificityItem => specificityItem.specificityType.id !== specificityType.id
			);

			this.specificities.push({
				specificityType,
				specificity: value
			});

			this.emitChangeEvent();
		},
		emitChangeEvent ()
		{
			let specificities = this.specificities;

			specificities = _.filter(specificities, item => item.specificityType.id !== this.motherSpecificityType.id);

			specificities.push({
				specificity: this.motherSpecificity,
				specificityType: this.motherSpecificityType
			});

			this.$emit('change', {
				valid: this.valid,
				item: this.item,
				specificities,
			});
		},
	},
}
</script>
